import { render } from "./EventFijiBsComponent.vue?vue&type=template&id=a6dadc88&scoped=true&ts=true"
import script from "./EventFijiBsComponent.vue?vue&type=script&lang=ts"
export * from "./EventFijiBsComponent.vue?vue&type=script&lang=ts"

import "./EventFijiBsComponent.vue?vue&type=style&index=0&id=a6dadc88&scoped=true&lang=scss"
import "./EventFijiBsComponent.vue?vue&type=style&index=1&id=a6dadc88&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6dadc88"]])

export default __exports__